module.exports = __webpack_public_path__ + "static/bgAsset-pz-b3dc936676850fc70cf7b4cc24ec80ed.jpg";